/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import { IUrlProp } from '../../components/url/component';
import { setLayersActiveWithOpacity, setPreview } from '../../modules/layers/actions';
import { setLocationHighlight, setMapStyle, setMapViewport } from '../../modules/map/actions';
import initialMapState, { INITIAL_VIEW_PORT } from '../../modules/map/initial-state';
import {
  reduxLayersToUrl,
  reduxViewportToUrl,
  urlToReduxLayers,
  urlToReduxViewport,
} from '../../utils/map';

export const URL_PROPS: IUrlProp[] = [
  {
    type: 'array',
    value: 'layers',
    redux: 'layers',
    action: setLayersActiveWithOpacity,
    required: false,
    mapValueToUrl: urlToReduxLayers,
    mapUrlToValue: reduxLayersToUrl,
  },
  {
    type: 'string',
    value: 'preview',
    redux: 'preview',
    action: setPreview,
    required: false,
    mapValueToUrl: (value) => value,
    mapUrlToValue: (value) => value,
  },
  {
    type: 'array',
    value: 'coordinates',
    redux: 'map.viewport',
    action: setMapViewport,
    required: false,
    mapValueToUrl: reduxViewportToUrl,
    mapUrlToValue: urlToReduxViewport(INITIAL_VIEW_PORT),
  },
  {
    type: 'string',
    value: 'basemap',
    redux: 'map.mapStyle',
    action: setMapStyle,
    required: false,
    mapValueToUrl: (value) => value || initialMapState.mapStyle,
    mapUrlToValue: (value) => value || initialMapState.mapStyle,
  },
];

export default {
  URL_PROPS,
};
